import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { Level } from '../level.model';

@JsonObject('LevelsResultsResponse')
export class LevelsResultsResponse extends ApiResultsResponse<Level> {

  @JsonProperty('results', [Level])
  override results: Level[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
